import { defaultApiState } from '@/store/types/general.types';
import { AxiosError } from 'axios';
import {
  PaginatedTrainersDTO,
  TrainerResponseDTO,
  TrainerState
} from './trainer.types';

export const trainerMutations = {
  GET_TRAINERS_SUCCESS(state: TrainerState, data: TrainerResponseDTO[]) {
    state.apiState.getTrainers = {
      ...defaultApiState,
      success: true
    };
    state.trainers = data;
  },
  GET_TRAINERS_LOADING(state: TrainerState) {
    state.apiState.getTrainers = {
      ...defaultApiState,
      loading: true
    };
    state.trainers = undefined;
  },
  GET_TRAINERS_ERROR(state: TrainerState, error: AxiosError) {
    state.apiState.getTrainers = {
      ...defaultApiState,
      error
    };
  },
  GET_PAGINATED_TRAINERS_LOADING(state: TrainerState) {
    state.apiState.getPaginatedTrainers = {
      ...defaultApiState,
      loading: true
    };
    state.paginatedTrainers = undefined;
  },
  GET_PAGINATED_TRAINERS_SUCCESS(
    state: TrainerState,
    data: PaginatedTrainersDTO
  ) {
    state.apiState.getPaginatedTrainers = {
      ...defaultApiState,
      success: true
    };
    state.paginatedTrainers = data;
  },
  GET_PAGINATED_TRAINERS_ERROR(state: TrainerState, error: AxiosError) {
    state.apiState.getPaginatedTrainers = {
      ...defaultApiState,
      error
    };
  }
};
